import { createFileRoute, redirect } from "@tanstack/react-router";

// Developer settings, retired by the sidebar IA reorg (2026-08-14). It held a
// transactional-vs-publication explainer table (deleted — product copy inside
// a settings surface) and the email-approval webhook, which now has its own
// route. Redirects there.
export const Route = createFileRoute("/dashboard/w/$workspaceId/developer/")({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: "/dashboard/w/$workspaceId/developer/webhook",
      params: { workspaceId: params.workspaceId },
    });
  },
});
